import type { Field, FormValues, AddressValue } from "../types";

function isFilled(v: unknown): boolean {
  if (v === undefined || v === null) return false;
  if (typeof v === "string") return v.trim().length > 0;
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === "boolean") return v;
  if (typeof v === "object") {
    const a = v as AddressValue;
    return Boolean(a.line1 || a.suburb || a.postcode);
  }
  return false;
}

export function fieldError(field: Field, value: unknown): string | null {
  if (field.required && !isFilled(value)) {
    return "This one's required.";
  }
  if (field.type === "textarea" && typeof value === "string" && value.length > 0) {
    if (field.minLength && value.trim().length < field.minLength) {
      return `A little more please — at least ${field.minLength} characters.`;
    }
    if (field.maxLength && value.length > field.maxLength) {
      return `Please keep it under ${field.maxLength} characters.`;
    }
  }
  if (field.type === "email" && typeof value === "string" && value.length > 0) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "That email doesn't look quite right.";
    }
  }
  if (field.type === "date" && typeof value === "string" && value.length > 0) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return "Use the format DD / MM / YYYY.";
    }
  }
  return null;
}

export function sectionErrors(fields: Field[], values: FormValues): Record<string, string> {
  const errors: Record<string, string> = {};
  for (const f of fields) {
    const e = fieldError(f, values[f.id]);
    if (e) errors[f.id] = e;
  }
  return errors;
}

export function ageFromDob(dobIso: string, today = new Date()): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dobIso);
  if (!m) return null;
  const [, y, mo, d] = m;
  const dob = new Date(Number(y), Number(mo) - 1, Number(d));
  if (Number.isNaN(dob.getTime())) return null;
  let age = today.getFullYear() - dob.getFullYear();
  const beforeBirthday =
    today.getMonth() < dob.getMonth() ||
    (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate());
  if (beforeBirthday) age--;
  return age;
}
